(() => {
  const root = document.querySelector('.paw-pdp[data-product-root]');
  if (!root) return;
  const videoGuideRow = root.querySelector('[data-pdp-watch-video]');
  const description = root.querySelector('[data-pdp-description]');
  if (videoGuideRow && description && !videoGuideRow.querySelector('a[href]')) {
    description.querySelectorAll('a[href]').forEach(link => {
      if (!/watch\s+video/i.test(link.textContent)) return;
      let destination;
      try {
        destination = new URL(link.getAttribute('href'), window.location.href);
      } catch {
        return;
      }
      if (!['https:', 'http:'].includes(destination.protocol)) return;
      const previousParent = link.parentElement;
      if (link.target === '_blank') {
        link.relList.add('noopener', 'noreferrer');
      }
      link.removeAttribute('style');
      videoGuideRow.append(link);
      videoGuideRow.hidden = false;
      if (previousParent.matches('p') && !previousParent.textContent.trim() && !previousParent.children.length) previousParent.remove();
    });
  }
  if (description) {
    let trailing = description.lastChild;
    while (trailing) {
      const previous = trailing.previousSibling;
      const emptyText = trailing.nodeType === Node.TEXT_NODE && !trailing.textContent.trim();
      const emptyMarkup = trailing.nodeType === Node.ELEMENT_NODE
        && trailing.matches('br, p, ul, ol')
        && !trailing.textContent.trim()
        && !trailing.querySelector('a, img, picture, svg, video, audio, iframe, canvas, table, input, button, select, textarea, hr, object, embed');
      if (!emptyText && !emptyMarkup) break;
      trailing.remove();
      trailing = previous;
    }
  }
  const couponSection = root.querySelector('[data-pdp-coupons]');
  if (couponSection) {
    const drawer = couponSection.querySelector('[data-pdp-coupons-dialog]');
    const toggle = couponSection.querySelector('[data-pdp-coupons-toggle]');
    toggle?.addEventListener('click', () => {
      if (!drawer || drawer.open) return;
      drawer.showModal();
      toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('paw-coupons-open');
    });
    drawer?.querySelector('[data-pdp-coupons-close]')?.addEventListener('click', () => drawer.close());
    drawer?.addEventListener('click', event => {
      if (event.target !== drawer) return;
      const bounds = drawer.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) drawer.close();
    });
    drawer?.addEventListener('close', () => {
      toggle?.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('paw-coupons-open');
      toggle?.focus({preventScroll: true});
    });
    const copyTimers = new WeakMap();
    couponSection.addEventListener('click', async event => {
      const button = event.target.closest('[data-pdp-coupon-copy]');
      if (!button || button.disabled) return;
      window.clearTimeout(copyTimers.get(button));
      const label = button.querySelector('[data-pdp-coupon-copy-label]') || button;
      const field = button.closest('[data-pdp-coupon]').querySelector('[data-pdp-coupon-field]');
      const status = (button.closest('[data-pdp-coupons-dialog]') || couponSection).querySelector('[data-pdp-coupons-status]');
      button.disabled = true;
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(button.dataset.pdpCouponCopy);
        field.hidden = true;
        label.textContent = couponSection.dataset.copiedLabel;
        button.classList.add('is-copied');
        status.textContent = couponSection.dataset.copySuccess;
        copyTimers.set(button, window.setTimeout(() => {
          if (!button.isConnected) return;
          label.textContent = couponSection.dataset.copyLabel;
          button.classList.remove('is-copied');
        }, 2000));
      } catch (_) {
        label.textContent = couponSection.dataset.copyLabel;
        button.classList.remove('is-copied');
        field.hidden = false;
        field.focus();
        field.select();
        status.textContent = couponSection.dataset.copyManual;
      } finally {
        status.hidden = false;
        button.disabled = false;
      }
    });
  }
  const deliveryForm = root.querySelector('[data-pdp-delivery-form]');
  if (deliveryForm) {
    const input = deliveryForm.elements.pincode;
    const result = deliveryForm.querySelector('[data-pdp-delivery-result]');
    const button = deliveryForm.querySelector('button');
    let zonesPromise;
    let requestId = 0;
    const loadZones = () => {
      if (!zonesPromise) {
        zonesPromise = fetch(deliveryForm.dataset.zonesUrl).then(response => {
          if (!response.ok) throw new Error('Delivery data unavailable');
          return response.json();
        }).then(data => {
          if (data.origin !== '400068' || !Array.isArray(data.bands) || data.bands.length !== 4) throw new Error('Invalid delivery data');
          const zones = new Map();
          data.bands.forEach((pins, band) => pins.forEach(pin => zones.set(pin, band)));
          return zones;
        }).catch(error => { zonesPromise = undefined; throw error; });
      }
      return zonesPromise;
    };
    input.addEventListener('input', () => {
      requestId++;
      input.removeAttribute('aria-invalid');
      result.classList.remove('is-error');
      result.textContent = '';
      result.hidden = true;
      button.disabled = false;
    });
    deliveryForm.addEventListener('submit', async event => {
      event.preventDefault();
      const current = ++requestId;
      const pin = input.value.trim();
      const valid = /^[1-9]\d{5}$/.test(pin);
      input.setAttribute('aria-invalid', String(!valid));
      result.classList.toggle('is-error', !valid);
      result.hidden = false;
      if (!valid) {
        result.textContent = deliveryForm.dataset.invalid;
        input.focus();
        return;
      }
      button.disabled = true;
      result.textContent = deliveryForm.dataset.loading;
      try {
        const zones = await loadZones();
        if (current !== requestId) return;
        const band = zones.get(pin);
        if (band === undefined) {
          result.textContent = deliveryForm.dataset.unknown;
          return;
        }
        const days = ['local', 'nearby', 'regional', 'distant'].map(key => deliveryForm.dataset[key])[band];
        result.textContent = deliveryForm.dataset.estimate.replace('{days}', days);
      } catch {
        if (current === requestId) result.textContent = deliveryForm.dataset.unknown;
      } finally {
        if (current === requestId) button.disabled = false;
      }
    });
  }
  root.querySelectorAll('.paw-pdp__description-more').forEach(details => {
    const summary = details.querySelector('summary');
    const content = details.querySelector('.rte');
    let expanded = details.open;
    let animation;
    summary.setAttribute('aria-expanded', String(expanded));
    summary.addEventListener('click', event => {
      event.preventDefault();
      const startHeight = details.getBoundingClientRect().height;
      expanded = !expanded;
      summary.setAttribute('aria-expanded', String(expanded));
      animation?.cancel();
      details.open = true;
      details.style.height = startHeight + 'px';
      details.style.overflow = 'hidden';
      const endHeight = summary.getBoundingClientRect().height + (expanded ? content.getBoundingClientRect().height + parseFloat(getComputedStyle(content).marginTop || 0) : 0);
      const current = details.animate([{height: startHeight + 'px'}, {height: endHeight + 'px'}], {
        duration: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 240,
        easing: 'ease-in-out'
      });
      animation = current;
      current.onfinish = () => {
        if (animation !== current) return;
        details.open = expanded;
        details.style.removeProperty('height');
        details.style.removeProperty('overflow');
        animation = undefined;
      };
    });
  });
  const header = document.querySelector('.paw-home-sticky-header') || document.querySelector('.site-header--sticky');
  if (header) {
    const updateGalleryOffset = () => root.style.setProperty('--paw-pdp-sticky-top', `${Math.ceil(header.getBoundingClientRect().height) + 16}px`);
    updateGalleryOffset();
    const headerObserver = new ResizeObserver(updateGalleryOffset);
    headerObserver.observe(header);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) headerObserver.disconnect();
    });
  }
  const $ = (s, context = root) => context.querySelector(s);
  const $$ = (s, context = root) => [...context.querySelectorAll(s)];
  const variants = JSON.parse($('[data-product-json]')?.textContent || '[]');
  const form = $('.product-form');
  const pairPrimarySelect = $('[data-pdp-bundle-primary-select]');
  let pairPrimaryConfirmed = pairPrimarySelect?.dataset.requireSelection !== 'true';
  let pairPrimaryCombinationValid = true;
  const money = cents => { try { return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {style:'currency',currency:document.body.dataset.currency || 'INR'}).format(cents/100); } catch (_) { return '₹'+(cents/100).toFixed(2); } };
  const quantityInput = $('[name="quantity"]', form);
  $('[data-quantity-minus]', form)?.addEventListener('click', () => { quantityInput.value = Math.max(1, Number(quantityInput.value || 1) - 1); });
  $('[data-quantity-plus]', form)?.addEventListener('click', () => { quantityInput.value = Math.max(1, Number(quantityInput.value || 1) + 1); });
  let galleryThumbs = $$('[data-product-thumb]');
  let activeImage = Math.max(0, galleryThumbs.findIndex(thumb => thumb.classList.contains('is-active')));
  const galleryImages = new Map();
  let galleryRequest = 0;
  let galleryPreloadTimer;
  const preloadGalleryImage = src => {
    if (!src) return null;
    if (galleryImages.has(src)) return galleryImages.get(src);
    const image = new Image();
    image.decoding = 'async';
    const entry = {image, ready: null};
    entry.ready = new Promise(resolve => {
      image.onload = () => resolve(true);
      image.onerror = () => {
        if (galleryImages.get(src) === entry) galleryImages.delete(src);
        resolve(false);
      };
    });
    galleryImages.set(src, entry);
    if (galleryImages.size > 12) galleryImages.delete(galleryImages.keys().next().value);
    image.src = src;
    return entry;
  };
  const showImage = index => {
    if (!galleryThumbs.length) return;
    activeImage = (index + galleryThumbs.length) % galleryThumbs.length;
    const request = ++galleryRequest;
    const thumb = galleryThumbs[activeImage], image = $('.product-gallery__main img');
    const src = thumb.dataset.imageSrc;
    const preview = thumb.querySelector('img');
    const loaded = preloadGalleryImage(src);
    if (image && src) {
      image.alt = preview?.alt || $('.product-info h1')?.textContent || '';
      const sameImage = new URL(image.currentSrc || image.src, location.href).pathname === new URL(src, location.href).pathname;
      if (loaded.image.complete && loaded.image.naturalWidth > 0) {
        image.removeAttribute('srcset');
        image.src = src;
      } else if (!sameImage) {
        image.removeAttribute('srcset');
        image.src = preview?.complete && preview.naturalWidth > 0 ? (preview.currentSrc || preview.src) : src;
      }
      loaded.ready.then(success => {
        if (!success || request !== galleryRequest || galleryThumbs[activeImage] !== thumb) return;
        image.removeAttribute('srcset');
        image.src = src;
        if (lightbox?.open) syncLightbox();
      });
    }
    galleryThumbs.forEach((item, i) => { item.classList.toggle('is-active', i === activeImage); item.setAttribute('aria-pressed', String(i === activeImage)); });
    const scroller = thumb.parentElement;
    const thumbBounds = thumb.getBoundingClientRect(), railBounds = scroller.getBoundingClientRect();
    if (thumbBounds.top < railBounds.top) scroller.scrollTop += thumbBounds.top - railBounds.top;
    else if (thumbBounds.bottom > railBounds.bottom) scroller.scrollTop += thumbBounds.bottom - railBounds.bottom;
    window.clearTimeout(galleryPreloadTimer);
    if (!navigator.connection?.saveData && galleryThumbs.length > 1) {
      galleryPreloadTimer = window.setTimeout(() => {
        [1, -1].forEach(step => preloadGalleryImage(galleryThumbs[(activeImage + step + galleryThumbs.length) % galleryThumbs.length]?.dataset.imageSrc));
      }, 150);
    }
  };
  const variantGalleries = JSON.parse($('[data-variant-galleries]')?.textContent || '{}');
  const defaultGallery = galleryThumbs.map(thumb => ({
    id: thumb.dataset.mediaId, src: thumb.dataset.imageSrc,
    thumb: thumb.querySelector('img')?.src, alt: thumb.querySelector('img')?.alt || ''
  }));
  const bindGallery = () => {
    galleryThumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => showImage(index));
      const warmImage = () => preloadGalleryImage(thumb.dataset.imageSrc);
      thumb.addEventListener('pointerenter', warmImage);
      thumb.addEventListener('focus', warmImage);
    });
  };
  const applyVariantGallery = variant => {
    let images = variantGalleries[String(variant.id)] || [];
    if (!images.length) {
      images = [...defaultGallery];
      const featured = variant.featured_image;
      if (featured?.src) {
        const imagePath = src => new URL(src, location.href).pathname;
        const matchingIndex = images.findIndex(image => imagePath(image.src) === imagePath(featured.src));
        const selectedImage = matchingIndex >= 0 ? images.splice(matchingIndex, 1)[0] : {id:String(featured.id),src:featured.src,thumb:featured.src,alt:featured.alt || $('.product-info h1')?.textContent || ''};
        images.unshift(selectedImage);
      }
    }
    const thumbnails = $('.product-thumbnails');
    if (!thumbnails || !images.length) return;
    thumbnails.replaceChildren();
    images.forEach((item,index) => {
      const thumb = document.createElement('button');
      thumb.type = 'button'; thumb.className = 'product-thumb';
      thumb.dataset.productThumb = ''; thumb.dataset.mediaId = item.id; thumb.dataset.imageSrc = item.src;
      thumb.setAttribute('aria-label', 'View image '+(index+1));
      const image = document.createElement('img');
      image.src = item.thumb || item.src; image.alt = item.alt || ''; image.loading = 'lazy';
      thumb.append(image); thumbnails.append(thumb);
    });
    galleryThumbs = $('[data-product-thumb]');
    // New thumbnails are gallery buttons, not option controls.
    galleryThumbs = [...thumbnails.children];
    const multiple = images.length > 1;
    root.classList.toggle('paw-pdp--single-image', !multiple);
    $('[data-thumb-rail]').hidden = !multiple;
    $('[data-gallery-prev]').hidden = $('[data-gallery-next]').hidden = !multiple;
    thumbnails.scrollTop = 0;
    bindGallery();
    showImage(0);
    if (lightbox?.open) syncLightbox();
    requestAnimationFrame(updateThumbControls);
  };
  const lightbox = $('[data-pdp-lightbox]');
  const lightboxImage = $('[data-lightbox-image]');
  const syncLightbox = () => {
    const image = $('.product-gallery__main img');
    if (!lightboxImage || !image) return;
    lightboxImage.src = galleryThumbs[activeImage]?.dataset.imageSrc || image.src;
    lightboxImage.alt = image.alt;
    const count = $('[data-lightbox-count]');
    if (count) count.textContent = (activeImage + 1) + ' / ' + galleryThumbs.length;
  };
  $('[data-open-image]')?.addEventListener('click', () => { syncLightbox(); lightbox?.showModal(); });
  $('[data-lightbox-close]')?.addEventListener('click', () => lightbox?.close());
  const stepLightbox = step => { showImage(activeImage + step); syncLightbox(); };
  $('[data-lightbox-prev]')?.addEventListener('click', () => stepLightbox(-1));
  $('[data-lightbox-next]')?.addEventListener('click', () => stepLightbox(1));
  lightbox?.addEventListener('click', event => { if (event.target === lightbox) lightbox.close(); });
  lightbox?.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); stepLightbox(event.key === 'ArrowRight' ? 1 : -1); }
  });
  const render = variant => {
    if (!variant) return;
    $('[data-variant-id]', form).value = variant.id;
    const add = $('[data-add-to-cart]', form);
    form.dataset.variantAvailable = String(variant.available);
    add.disabled = !variant.available;
    const payment = $('[data-pdp-payment]', form);
    if (payment) payment.hidden = !variant.available;
    $('[data-add-label]', form).textContent = variant.available ? form.dataset.addLabel : form.dataset.soldOutLabel;
    const price = $('[data-product-price]');
    price.hidden = false;
    $('strong', price).textContent = money(variant.price);
    const compare = $('s', price), save = $('.paw-pdp__save', price);
    const hasCompare = variant.compare_at_price > variant.price;
    const discount = hasCompare ? Math.floor((variant.compare_at_price-variant.price)*100/variant.compare_at_price) : 0;
    compare.hidden = !hasCompare;
    save.hidden = !discount;
    if (hasCompare) compare.textContent = money(variant.compare_at_price);
    const additionalMrp = $('[data-pdp-additional-mrp]');
    if (additionalMrp) {
      const mrp = Number(variant.compare_at_price);
      additionalMrp.closest('[data-pdp-additional-mrp-row]').hidden = !(mrp > 0);
      additionalMrp.textContent = mrp > 0 ? money(mrp) : '';
    }
    if (discount) save.textContent = price.dataset.saveLabel.replace('__percent__', discount);
    const sku = $('.paw-pdp__sku'); sku.hidden = !variant.sku; $('[data-pdp-sku]').textContent = variant.sku || '';
    $$('[data-pdp-variant]').forEach(button => { const active = button.dataset.pdpVariant === String(variant.id); button.classList.toggle('is-active',active); button.setAttribute('aria-pressed',active); });
    const bundle = $('[data-pdp-bundle]');
    if (bundle) {
      $('[data-pdp-bundle-primary]').textContent = money(variant.price);
      $('[data-pdp-bundle-primary-option]').textContent = variant.title === 'Default Title' ? '' : variant.title;
      updatePair();
    }
    applyVariantGallery(variant);
  };
  const syncVariantUrl = variant => {
    const url = new URL(location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState({}, '', url.pathname + url.search + url.hash);
  };
  $$('.product-option input').forEach(input => input.addEventListener('change', () => {
    if (input.closest('[data-size-option]')) pairPrimaryConfirmed = true;
    const values = $$('.product-option input:checked').map(item => item.value);
    $$('.product-option').forEach(fieldset => { const chosen = $('input:checked', fieldset); if (chosen) $('[data-option-label]', fieldset).textContent = chosen.value; });
    const variant = variants.find(item => item.options.every((option,index) => option === values[index]));
    pairPrimaryCombinationValid = Boolean(variant);
    if (variant) { render(variant); syncVariantUrl(variant); }
    else {
      $('[data-variant-id]', form).value = '';
      form.dataset.variantAvailable = 'false';
      $('[data-add-to-cart]', form).disabled = true;
      $('[data-add-label]', form).textContent = form.dataset.unavailableLabel;
      $('[data-product-price]').hidden = true;
      const additionalMrpRow = $('[data-pdp-additional-mrp-row]');
      if (additionalMrpRow) additionalMrpRow.hidden = true;
      $('.paw-pdp__sku').hidden = true;
      const payment = $('[data-pdp-payment]', form);
      if (payment) payment.hidden = true;
      $$('[data-pdp-variant]').forEach(button => { button.classList.remove('is-active'); button.setAttribute('aria-pressed', 'false'); });
      updatePair();
    }
  }));
  $$('[data-pdp-variant]').forEach(button => button.addEventListener('click', () => {
    const variant = variants.find(item => String(item.id) === button.dataset.pdpVariant);
    if (!variant) return;
    pairPrimaryConfirmed = true;
    pairPrimaryCombinationValid = true;
    $$('.product-option').forEach((fieldset,index) => {
      const radio = $$('input',fieldset).find(item => item.value === variant.options[index]);
      if (radio) { radio.checked = true; $('[data-option-label]',fieldset).textContent = radio.value; }
    });
    render(variant);
    syncVariantUrl(variant);
  }));
  const tabs = $$('.paw-pdp__tabs [role=tab]');
  const activate = tab => { tabs.forEach(item => { const active = item === tab; item.setAttribute('aria-selected',active); item.tabIndex = active ? 0 : -1; $('#'+item.getAttribute('aria-controls')).hidden = !active; }); };
  tabs.forEach((tab,index) => { tab.addEventListener('click',() => activate(tab)); tab.addEventListener('keydown', event => { if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return; event.preventDefault(); const next = tabs[(index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length]; activate(next); next.focus(); }); });
  $('[data-open-reviews]')?.addEventListener('click', event => {
    const reviewTab = tabs.find(tab => tab.getAttribute('aria-controls')?.startsWith('PdpPanel-reviews-'));
    if (!reviewTab) return;
    event.preventDefault();
    activate(reviewTab);
    reviewTab.scrollIntoView({behavior:'smooth',block:'start'});
  });
  const shippingDialog = $('[data-pdp-shipping]');
  $$('[data-pdp-shipping-open]').forEach(button => button.addEventListener('click', () => shippingDialog?.showModal()));
  $('[data-pdp-shipping-close]')?.addEventListener('click', () => shippingDialog?.close());
  shippingDialog?.addEventListener('click', event => { if (event.target === shippingDialog) shippingDialog.close(); });
  const sizeGuide = $('[data-pdp-size-guide]');
  $$('[data-pdp-size-guide-open]').forEach(button => button.addEventListener('click', () => sizeGuide?.showModal()));
  $('[data-pdp-size-guide-close]')?.addEventListener('click', () => sizeGuide?.close());
  sizeGuide?.addEventListener('click', event => { if (event.target === sizeGuide) sizeGuide.close(); });
  const thumbScroller = $('.product-thumbnails');
  const thumbRail = $('[data-thumb-rail]');
  const scrollPrevious = $('[data-thumb-scroll-prev]');
  const scrollNext = $('[data-thumb-scroll-next]');
  const updateThumbControls = () => {
    if (!thumbScroller || !thumbRail) return;
    const scrollable = thumbScroller.scrollHeight > thumbScroller.clientHeight + 1;
    thumbRail.classList.toggle('is-static', !scrollable);
    scrollPrevious.hidden = scrollNext.hidden = !scrollable;
    scrollPrevious.disabled = thumbScroller.scrollTop <= 1;
    scrollNext.disabled = thumbScroller.scrollTop + thumbScroller.clientHeight >= thumbScroller.scrollHeight - 1;
  };
  scrollPrevious?.addEventListener('click', () => thumbScroller.scrollBy({top:-Math.max(100,thumbScroller.clientHeight * .75),behavior:'smooth'}));
  scrollNext?.addEventListener('click', () => thumbScroller.scrollBy({top:Math.max(100,thumbScroller.clientHeight * .75),behavior:'smooth'}));
  thumbScroller?.addEventListener('scroll', updateThumbControls, {passive:true});
  const mainGallery = $('.product-gallery__main');
  if (mainGallery) {
    const galleryObserver = new ResizeObserver(() => {
      root.style.setProperty('--paw-gallery-height', mainGallery.getBoundingClientRect().height + 'px');
      updateThumbControls();
    });
    galleryObserver.observe(mainGallery);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) galleryObserver.disconnect();
    });
  }
  window.addEventListener('resize', updateThumbControls);
  requestAnimationFrame(updateThumbControls);
  bindGallery();
  $('[data-gallery-prev]')?.addEventListener('click', () => showImage(activeImage - 1));
  $('[data-gallery-next]')?.addEventListener('click', () => showImage(activeImage + 1));
  const updatePair = () => {
    const second = $('[data-pdp-bundle-second]');
    if (!second) return;
    const primary = variants.find(item => String(item.id) === $('[data-variant-id]', form).value);
    $('[data-pdp-bundle-total]').textContent = money((primary?.price || 0) + Number(second.dataset.pdpBundlePrice));
    if (pairPrimarySelect) pairPrimarySelect.value = pairPrimaryConfirmed && pairPrimaryCombinationValid ? String(primary?.id || '') : '';
    const hint = $('[data-pdp-bundle-primary-hint]');
    if (hint) hint.hidden = pairPrimaryConfirmed;
    const primaryImage = $('[data-pdp-bundle-primary-product] img');
    const imageSrc = primary?.featured_image?.src || $('[data-pdp-bundle-primary-product]')?.dataset.defaultImage;
    if (primaryImage && imageSrc) { primaryImage.removeAttribute('srcset'); primaryImage.src = imageSrc; }
    const ready = pairPrimaryConfirmed && pairPrimaryCombinationValid && Boolean(primary?.available) && second.dataset.pdpBundleAvailable === 'true';
    $('[data-pdp-bundle-add]').disabled = !ready;
    return ready;
  };
  pairPrimarySelect?.addEventListener('change', () => {
    const variant = variants.find(item => String(item.id) === pairPrimarySelect.value);
    if (!variant?.available) return;
    pairPrimaryConfirmed = true;
    pairPrimaryCombinationValid = true;
    $$('.product-option').forEach((fieldset, index) => {
      const radio = $$('input', fieldset).find(item => item.value === variant.options[index]);
      if (radio) { radio.checked = true; $('[data-option-label]', fieldset).textContent = radio.value; }
    });
    render(variant);
    syncVariantUrl(variant);
    $('[data-pdp-bundle-message]').textContent = '';
  });
  $$('[data-size-option] input').forEach(input => input.addEventListener('click', () => {
    pairPrimaryConfirmed = true;
    updatePair();
  }));
  $('[data-pdp-bundle-select]')?.addEventListener('change', event => {
    const option = event.target.selectedOptions[0];
    const second = $('[data-pdp-bundle-second]');
    second.dataset.pdpBundleSecond = option.value;
    second.dataset.pdpBundlePrice = option.dataset.price;
    second.dataset.pdpBundleAvailable = option.dataset.available;
    $('[data-pdp-bundle-companion-price]').textContent = money(Number(option.dataset.price));
    const image = $('[data-pdp-bundle-companion] img');
    if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
    $('[data-pdp-bundle-message]').textContent = '';
    updatePair();
  });
  const pairPrimaryOption = $('[data-pdp-bundle-primary-option]');
  if (pairPrimaryOption?.textContent.trim() === 'Default Title') pairPrimaryOption.textContent = '';
  updatePair();
  $('[data-pdp-bundle-add]')?.addEventListener('click', async event => {
    if (!updatePair()) return;
    const button = event.currentTarget;
    const id = Number($('[data-variant-id]',form).value), second = Number($('[data-pdp-bundle-second]').dataset.pdpBundleSecond);
    button.disabled = true;
    $('[data-pdp-bundle-message]').textContent = '';
    try {
      await window.PawCart.mutate(async refresh => {
        const response = await fetch((window.Shopify?.routes?.root || '/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id,quantity:1},{id:second,quantity:1}]})});
        if (!response.ok) throw new Error('Cart request failed');
        await refresh();
      });
      location.assign((window.Shopify?.routes?.root || '/')+'cart');
    } catch (_) { $('[data-pdp-bundle-message]').textContent = 'Could not add both. Please try again.'; updatePair(); }
  });
  const initialVariant = variants.find(item => String(item.id) === $('[data-variant-id]', form)?.value);
  if (initialVariant) render(initialVariant);
  const recommendations = document.querySelector('.paw-pdp-recommendations[data-product-recommendations]');
  if (recommendations) {
    const observer = new MutationObserver(() => {
      if (!recommendations.querySelector('[data-paw-best-rail]')) return;
      observer.disconnect();
      delete recommendations.dataset.pawBestReady;
      recommendations.dispatchEvent(new Event('shopify:section:load',{bubbles:true}));
    });
    observer.observe(recommendations,{childList:true});
  }
})();









